// src/components/layout/PageLayout.tsx
// ============================================================
// SALT — Page Layout Wrapper
// Renders Navbar + page content. Wrap routes that need the
// navbar with this component. Routes like AuthPage that should
// be fullscreen simply don't use PageLayout.
// ============================================================

import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import ErrorBoundary from '../common/ErrorBoundary';

interface PageLayoutProps {
  children: React.ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  const { pathname } = useLocation();

  return (
    <>
      <Navbar />
      <main>
        {/* key resets the boundary when the user navigates away from a crashed page */}
        <ErrorBoundary key={pathname}>{children}</ErrorBoundary>
      </main>
    </>
  );
}
